import { F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'
import {
  IncentivesCompensationPlansDataCollectionDocument,
  IncentivesDeleteCompensationPlanDocument,
} from 'generated/resources/graphql'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { useMutation } from 'modules/core/hooks/useMutation'
import app from 'modules/core/store/models/app'

interface DeleteCompensationPlanDialogProps {
  isOpen: boolean
  onClose: () => void
  planId: string
  onSuccess: () => void
}

export function DeleteCompensationPlanDialog({
  isOpen,
  onClose,
  planId,
  onSuccess,
}: DeleteCompensationPlanDialogProps) {
  const [deleteCompensationPlan, { loading }] = useMutation(
    IncentivesDeleteCompensationPlanDocument,
    {
      extractorFn: (data) => data.incentivesMutations.deleteIncentivesCompensationPlan,
      refetchQueries: [IncentivesCompensationPlansDataCollectionDocument],
      awaitRefetchQueries: true,
    }
  )

  const handleConfirm = async () => {
    const result = await deleteCompensationPlan({
      variables: { id: planId },
    })

    const handled = handleResult(result, () =>
      app.setFlash({
        type: 'wrong',
        message: i18n.t('incentives.detail.delete_plan.error_message'),
      })
    )

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onSuccess()
    }
  }

  return (
    <F0Dialog
      isOpen={isOpen}
      title={i18n.t('incentives.detail.delete_plan.modal_title')}
      onClose={onClose}
      width="sm"
      primaryAction={{
        label: i18n.t('incentives.detail.delete_plan.modal_confirm'),
        onClick: handleConfirm,
        loading,
        variant: 'critical',
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
      }}
    >
      <F0Box display="flex" flexDirection="column" gap="md">
        <F0Text content={i18n.t('incentives.detail.delete_plan.modal_body')} />
      </F0Box>
    </F0Dialog>
  )
}
